import React from 'react';
import { PageHeader } from 'components';
import { Form, Col, Row, Button, Spin, Table, Typography, Select } from 'antd';
import styles from './style.module.scss';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import FileSection from './formSections/file';
import FormHelper from 'helpers/FormHelper';
import useInvoiceMonthlies from '../useInvoiceMonthlies';
import moment from 'moment';
import UIHelper from 'helpers/UIHelper';
import { ActionModal } from 'components';
import { useNavigate } from 'hooks/useNavigate';
import { useLocation } from 'react-router-dom';

const New = ({ isNew }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const {
    form,
    handleCreate,
    updateInProcess,
    shops,
    inactiveShops,
    loading,
    isShowedPopup,
    setIsShowedPopup,
    showModal,
    setShowModal,
  } = useInvoiceMonthlies(false);

  const onFinish = async (values) => {
    await handleCreate(values, 'stepOne');
  };

  const handleCancel = () => {
    setShowModal(false);
    setIsShowedPopup(true);
    return navigate(UIHelper.getListRoute(pathname, 1));
  };
  // const companyId =  form.getFieldValue('company_id');
  // const api = new InvoiceMonthlies();
  // const data = await api.confirm_replace(companyId);
  // if (!data || data?.errors?.length) return false;
  // if (isConfirmable && !isShowedPopup) {
  //   setTempFile(file);
  //   setShowModal(true);
  //   return false;
  // }
  // return handlePopupAction(file);

  const onFinishFailed = (errorInfo) => {
    UIHelper.openNotificationWithIcon(
      'error',
      errorInfo.errorFields[0].errors[0],
    );
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = t('PUBBLICA FATTURATO MENSILE');
  const actionModalBody = <div> </div>;
  const isLoaded = shops?.[0];

  return (
    <div>
      <PageHeader title={title} />
      {!isLoaded ? (
        <div className={styles.spinLoader}>
          <Spin spinning={true} />
        </div>
      ) : (
        <div className={styles.content}>
          <Form
            form={form}
            name='basic'
            wrapperCol={{ span: 24 }}
            initialValues={{
              month: moment().format('MM'),
              year: moment().format('YYYY'),
              company_id: shops?.[0]?.value || null,
              file: null,
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
            onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
          >
            {!loading && (
              <>
                <InfoSection
                  isNew={isNew}
                  shops={shops}
                  inactiveShops={inactiveShops}
                />
                <Row gutter={16}>
                  <Col offset={6} span={9}>
                    <Form.Item
                      label={t('Mese')}
                      name='month'
                      rules={[
                        { required: true, message: t('Please select a month') },
                      ]}
                    >
                      <Select>
                        <Select.Option value='01'>01</Select.Option>
                        <Select.Option value='02'>02</Select.Option>
                        <Select.Option value='03'>03</Select.Option>
                        <Select.Option value='04'>04</Select.Option>
                        <Select.Option value='05'>05</Select.Option>
                        <Select.Option value='06'>06</Select.Option>
                        <Select.Option value='07'>07</Select.Option>
                        <Select.Option value='08'>08</Select.Option>
                        <Select.Option value='09'>09</Select.Option>
                        <Select.Option value='10'>10</Select.Option>
                        <Select.Option value='11'>11</Select.Option>
                        <Select.Option value='12'>12</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col offset={6} span={9}>
                    <Form.Item
                      label={t('Anno')}
                      name='year'
                      rules={[
                        { required: true, message: t('Please select a year') },
                      ]}
                    >
                      <Select>
                        {Array.from({ length: 11 }, (_, i) => {
                          const year =
                            parseInt(moment().format('YYYY')) - 10 + i;
                          return (
                            <Select.Option key={year} value={year.toString()}>
                              {year}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <FileSection form={form} />
              </>
            )}
          </Form>
          <Row gutter={16}>
            <Col span={6}>
              <Typography.Title level={3}>{t('Esempio')}</Typography.Title>
            </Col>
            <div>
              <Typography.Text
                style={{
                  fontSize: '14px',
                  display: 'block',
                  marginBottom: '10px',
                  paddingInline: '12px',
                }}
              >
                Nel file da caricare devono essere presenti i decimali per gli
                importi in Euro (€)​
              </Typography.Text>
              <Table
                pagination={false}
                columns={[
                  {
                    title: t('Data'),
                    dataIndex: 'date',
                  },
                  {
                    title: t('Imponibile Netto (€)'),
                    dataIndex: 'netto',
                  },
                  {
                    title: t('Imponibile Lordo (€)'),
                    dataIndex: 'lordo',
                  },
                  {
                    title: t('N. Scontrini'),
                    dataIndex: 'transactions',
                  },
                  {
                    title: t('N. Pezzi Venuti'),
                    dataIndex: 'sold_items_count',
                  },
                ]}
                dataSource={[
                  {
                    date: '01/01/2024',
                    netto: '100,01',
                    lordo: '122.00',
                    transactions: 1,
                    sold_items_count: 3,
                  },
                  {
                    date: '02/02/2024',
                    netto: '110,00',
                    lordo: '134,20',
                    transactions: 2,
                    sold_items_count: 5,
                  },
                  {
                    date: '03/01/2024',
                    netto: '100,01',
                    lordo: '122.00',
                    transactions: 5,
                    sold_items_count: 9,
                  },
                  {
                    date: '04/01/2024',
                    netto: '111,00',
                    lordo: '135,42',
                    transactions: 1,
                    sold_items_count: 1,
                  },
                  {
                    date: '05/01/2024',
                    netto: '157,00',
                    lordo: '191,54',
                    transactions: 1,
                    sold_items_count: 2,
                  },
                ]}
              />
            </div>
          </Row>
          <Row gutter={16}>
            <Col>
              <Button
                onClick={onClickSave}
                width={'150px'}
                big
                loading={updateInProcess}
                icon={<CheckOutlined />}
                disabled={!form.validateFields}
              >
                {t('Invia')}
              </Button>
            </Col>
            {isShowedPopup && (
              <ActionModal
                // loading={loading}
                show={showModal}
                title={t('dati_Veranno')}
                description={''}
                yesBtnText={t('Invia')}
                noBtnText={t('No, lascia.')}
                onClickOk={() => handleCreate({}, 'stepTwo')}
                onCancel={handleCancel}
                type={'info'}
              >
                {actionModalBody}
              </ActionModal>
            )}
          </Row>
        </div>
      )}
    </div>
  );
};

export default New;
